import React from 'react';
import Prism from 'prismjs';
import classNames from 'classnames';
import CopyToClipboard from './CopyToClipboard';

const CopyableSnippet = ({ isInline = true, lang = 'css', code, className = '' }) => 
  <CopyToClipboard className={classNames('clipboard-code', className, {"clipboard-code--inline": isInline })} clipboardText={code}>
    <pre dangerouslySetInnerHTML={{ __html: Prism.highlight(code, Prism.languages[lang], code) }} />
  </CopyToClipboard>

export default CopyableSnippet;
